import { useStyles } from './style';
import { Transaction } from '@tcs/client-portal-api/types/Transaction';
import { Typography } from '@forgeglobal/design-framework';
import AccountTransactionsTable from '@tcs/client-portal-common/components/molecules/AccountTransactionsTable';

interface Props {
  title?: string;
  transactions: Transaction[];
  loading: boolean;
}

export const AccountActivityTable = ({
  title = 'Recent Transactions',
  transactions,
  loading,
}: Props) => {
  const classes = useStyles();

  return (
    <div>
      <Typography
        variant="h5"
        color="textPrimary"
        className={classes.title}
        data-test-id="activity-table-title">
        {title}
      </Typography>
      <AccountTransactionsTable
        transactions={transactions}
        loading={loading}
        showBalance
        showUnits={false}
      />
    </div>
  );
};

export default AccountActivityTable;
